import { UserActivity } from './user-activity';
export class UserSubactivity {
  constructor(
    public hash?: string,
    public name?: string,
    public userActivity?: UserActivity
  ) { }

  clone() {
    return new UserSubactivity(
      this.hash,
      this.name,
      this.userActivity
    );
  }

  get userActivityName() {
    return this.userActivity ? this.userActivity.name : '';
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/user-subactivity.ts